<template>
  <v-container>
    <vuescroll
      :ops="{
        bar: {
          background: '#bacfcec0',
          keepShow: true,
        },
      }"
    >
      <v-data-table
        :headers="registerHeaders"
        :items="registerList"
        class="elevation-0"
        :loading="isLoadingRegisters"
        :no-data-text="noDataText"
        show-expand
        hide-default-footer
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <expandable-row :item="item" @goToCall="getCallNow"></expandable-row>
          </td>
        </template>
        <template v-slot:[`item.status_register_id`]="{ item }">
          {{ showStatusName(item.status_register_id) }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="openCallDialog(item)">
              <v-icon>mdi-phone</v-icon>
            </v-btn>
          </v-hover>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="getTypification({ call_number: item.telefono1, name: '' })"
            >
              <v-icon>mdi-star</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </vuescroll>
    <dialer-dialog
      v-if="isOpenDialer"
      :isOpenDialer="isOpenDialer"
      :item="itemToDialer"
      :onSubmit="getCallNow"
      @dialog:change="closeDialerDialog"
    ></dialer-dialog>
    <change-status
      v-if="isOpenChangeStatusDialog"
      :isOpen="isOpenChangeStatusDialog"
      :numberSelected="numberSelected"
      :dataToEdit="dataToEdit"
      :statusList="statusList"
      :campaignId="campaignId"
      @dialog:change="closeChangeStatusDialog"
    ></change-status>

    <typification-form
      v-if="isOpenTypification"
      :dialog="isOpenTypification"
      @close:dialog="handleCloseTypification"
      :temporaryTableId="typificationData.temporaryTableId"
      :queueNumber="typificationData.queueNumberSelected"
    />
  </v-container>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import DialerDialog from "./DialerDialog.vue";
import ChangeStatus from "./ChangeStatus.vue";
import ExpandableRow from "./ExpandableRow.vue";
import TypificationForm from "@/views/app/agents/Typification/TypificationForm.vue";

export default {
  props: {
    campaignId: {
      type: Number,
    },
    isCustomSearch: {
      type: Boolean,
    },
    payloadSearch: {
      type: Object,
    },
    campaignType: {
      type: String,
    },
    clientId: {},
  },
  components: { vuescroll, DialerDialog, ChangeStatus, ExpandableRow, TypificationForm },

  data() {
    return {
      isLoadingRegisters: true,
      isOpenChangeStatusDialog: false,
      isOpenDialer: false,
      isOpenTypification: false,
      numberSelected: null,
      registerId: null,
      phoneToCall: null,
      queueToCall: null,
      dataToEdit: {},
      itemToDialer: {},
      typificationData: { temporaryTableId: null, queueNumberSelected: null },
      statusList: [],
      registerList: [],
      registerHeaders: [
        { text: "Nombre", value: "name", width: "20%" },
        { text: "DNI", value: "dni", width: "10%" },
        { text: "Status", value: "status_register_id", width: "15%" },
        { text: "Fecha de creado", value: "created_at", width: "20%" },
        { text: "Dirección", value: "direction", width: "15%" },
        { text: "Acciones", value: "action", width: "15%" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  computed: {
    noDataText() {
      return this.isCustomSearch ? "No hay registros que coincidan con la búsqueda" : "No existen campañas";
    },
  },
  created() {
    this.getStatus();
    if (this.isCustomSearch) this.getCustomRegisters();
    else this.getRegisters();
  },

  watch: {
    // registerList(val) {
    //   if (val.length && this.campaignType === "Cola") {
    //     // console.log("watch", val);
    //     this.$store.dispatch("dialer/TOGGLE_OPEN_DIALOG");
    //   }
    // },

    isCustomSearch(val) {
      if (val) this.getCustomRegisters();
    },
    payloadSearch: {
      handler() {
        this.getCustomRegisters();
      },
      deep: true,
    },
  },

  methods: {
    openChangeStatusDialog(item = false) {
      this.dataToEdit = item || this.registerList[0];
      this.isOpenChangeStatusDialog = true;
    },

    closeChangeStatusDialog(newStatus) {
      if (newStatus.status) this.registerList = [newStatus];
      this.isOpenChangeStatusDialog = false;
      this.dataToEdit = {};
      this.closeRegister(newStatus.id);
      this.getRegisters();
    },
    openCallDialog(item) {
      this.itemToDialer = item;
      this.isOpenDialer = true;
    },
    closeDialerDialog() {
      this.isOpenDialer = false;
      this.itemToDialer = {};
    },
    showStatusName(id) {
      return this.statusList.find((el) => el.id === id)?.name;
    },

    async getRegisters() {
      this.isLoadingRegisters = true;
      try {
        const { data } = await PbxHttpClient.get(`/campaign/assign_register/${this.campaignId}`);
        if (typeof data !== "object" || Object.keys(data).length === 0) this.registerList = [];
        else this.registerList = [data];
      } catch (err) {
        this.$snotify.error("Hubo un error cargando los registros", "Error");
        // console.log(err);
      }
      this.isLoadingRegisters = false;
    },
    async getCustomRegisters() {
      this.isLoadingRegisters = true;
      try {
        const { data } = await PbxHttpClient.post(`campaign/search_register/${this.campaignId}`, this.payloadSearch);
        // console.log("details", data);
        this.registerList = data.data.length > 1 ? [data?.data[0]] : data?.data;
      } catch (err) {
        this.$snotify.error("Hubo un error o no se encontraron registros", "Error");
        // console.log(err);
      }
      this.isLoadingRegisters = false;
    },

    async getCallNow(number, id) {
      // console.log("phone selected:", number);
      try {
        this.numberSelected = number;
        this.$store.dispatch("dialer/CHANGE_IS_FOR_CAMPAIGNS_REGISTER", true);

        await PbxHttpClient.post(`campaign/call_number/${number}`, {
          campaign_id: this.campaignId,
          register_id: id,
          // TODO AQUI
        });
        this.$snotify.success("Llamada realizada con éxito.", "¡Hecho!");
        this.closeDialerDialog();
        this.getTypification({ call_number: number, name: "" });
      } catch (err) {
        // console.log("error calling now:", err);
        if (err.response) this.$snotify.error(err.response?.data?.error, "¡Error!");
        else this.$snotify.error("Hubo un error, intente mas tarde.", "¡Error!");
      }
    },
    async getStatus() {
      try {
        const { data } = await PbxHttpClient.get(`campaign/status_register`);
        this.statusList = data;
      } catch (err) {
        // console.log("error getting status:", err);
        this.$snotify.error("Hubo un error buscando los estados, intente mas tarde.", "¡Error!");
      }
    },

    async getTypification(payload) {
      try {
        // console.log("payload", payload);
        await new Promise((res) =>
          setTimeout(() => {
            res();
          }, 2000),
        );
        const { data } = await PbxHttpClient.get(`/typing/typing_call/get`, {
          params: {
            extension: this.hasRTC ? undefined : this.extensionVariableValue,
          },
        });
        const item = data.data.find((call) => call.call_number === payload.call_number);
        this.typificationData = {
          temporaryTableId: item.id,
          queueNumberSelected: payload.queue,
        };
        this.isOpenTypification = true;
      } catch (error) {
        // console.log(error);
        this.$snotify.error("Hubo un error buscando la tipificacion.", "¡Error!");
      }
    },

    async handleCloseTypification(wasSent = false) {
      try {
        this.isOpenTypification = false;
        this.$store.dispatch("dialer/CHANGE_IS_FOR_CAMPAIGNS_REGISTER", false);

        if (!wasSent) return;

        const register = this.registerList[0];
        await PbxHttpClient.put(`/campaign/register/${register.id}`, {
          ...register,
          status_register_id: 3,
        });
        this.closeRegister(register.id);
        this.getRegisters();
      } catch (error) {
        console.log("error", error);
      }
    },
    async closeRegister(registerId) {
      try {
        await PbxHttpClient.get(`campaign/remove_register/${registerId}`);
      } catch (err) {
        // console.log("error calling now:", err);
        if (err.response) this.$snotify.error(err.response?.data?.error, "¡Error!");
        else this.$snotify.error("Hubo un error, intente mas tarde.", "¡Error!");
      }
    },
  },
};
</script>

<style></style>
